module.exports = {
      id: "line-arrow-prev-usage",
      viewBox: "0 0 28 28",
      url: "/" + "sprite-ab56b996b385d9abaaf31e01c38c81cd.svg#line-arrow-prev",
      toString: function () {
        return this.url;
      }
    }